<template>
    <div>
        <lunbo></lunbo>
        <div style="width: 100%;background: #fff;padding: 0px 24px;margin-bottom: 20px;">
            <information></information>
            <nominating></nominating>
            <award></award>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
import lunbo from '@/components/lunbo.vue';
import Footer from '@/components/Footer.vue';
import information from './information.vue';
import nominating from './nominating.vue';
import award from './award.vue';
export default {
    components: {
        lunbo,
        information,
        nominating,
        award,
        Footer
    },
}
</script>
<style lang="less" scoped></style>